var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "w-100",
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "290",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "text-h6 text-center",
                },
                [_vm._v("\n        " + _vm._s(_vm.dialog_message) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), (_vm.deldigit = false)
                        },
                      },
                    },
                    [_vm._v("\n          ยกเลิก\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), _vm.specialButtonDel()
                        },
                      },
                    },
                    [_vm._v("\n          ยืนยัน\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedDigitType == 1
        ? _c(
            "div",
            {
              staticClass: "row-old-col",
            },
            _vm._l(_vm.digits_any, function (item, index) {
              return _c("button-item", {
                key: item.index,
                staticClass: "col-2",
                attrs: {
                  "class-button": _vm.getRateClass(_vm.digitType, item),
                  "key-value": item,
                  "lotto-numbers-with-type": _vm.lottoNumbersWithType,
                  "digit-type": _vm.digitType,
                },
                on: {
                  "child-digitClick": _vm.digitClick,
                },
              })
            }),
            1
          )
        : _vm.selectedDigitType == 2
        ? _c(
            "div",
            {
              staticClass: "row-old-col",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.nineTeenDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("nineteen")
                                },
                              },
                            },
                            [_vm._v("\n            19 ประตู\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.frontDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("front")
                                },
                              },
                            },
                            [_vm._v("\n            รูดหน้า\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.backDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("back")
                                },
                              },
                            },
                            [_vm._v("\n            รูดหลัง\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.evenNumberDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("evenNumber")
                                },
                              },
                            },
                            [_vm._v("\n            คู่\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.oddDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("odd")
                                },
                              },
                            },
                            [_vm._v("\n            คี่\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.highDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("high")
                                },
                              },
                            },
                            [_vm._v("\n            สูง\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.lowDigit,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.specialButtonGruop("low")
                                },
                              },
                            },
                            [_vm._v("\n            ต่ำ\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-pink-custom px-0 py-3",
                              class: {
                                active: _vm.doubleDigit,
                              },
                              on: {
                                click: _vm.doubleButton,
                              },
                            },
                            [_vm._v("\n            เบิ้ล\n          ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.specialDigit && _vm.specialDigit != "double"
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 my-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-6 px-0 mb-2 d-flex",
                                    },
                                    _vm._l(
                                      _vm.specialButtons,
                                      function (item, digit, digitActive) {
                                        return digit < 5
                                          ? _c(
                                              "div",
                                              {
                                                key: item.digit + digit,
                                                staticClass: "flex-width mx-1",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn w-100 btn-outline-pink mx-0 px-2 py-2",
                                                    class: {
                                                      active: item.digitActive,
                                                    },
                                                    attrs: {
                                                      "data-buttonType":
                                                        _vm.specialDigit,
                                                      "data-buttonDigit":
                                                        item.digit,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.specialButtonClick,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(digit) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-6 px-0 mb-2 d-flex",
                                    },
                                    _vm._l(
                                      _vm.specialButtons,
                                      function (item, digit, digitActive) {
                                        return digit >= 5
                                          ? _c(
                                              "div",
                                              {
                                                key: item.digit + digit,
                                                staticClass: "flex-width mx-1",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn w-100 btn-outline-pink mx-0 px-2 py-2",
                                                    class: {
                                                      active: item.digitActive,
                                                    },
                                                    attrs: {
                                                      "data-buttonType":
                                                        _vm.specialDigit,
                                                      "data-buttonDigit":
                                                        item.digit,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.specialButtonClick,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(digit) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 mt-3",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row-old-col",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 px-1 mb-2",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "w-100 btn btn-outline-dark py-3",
                              class: {
                                active: _vm.shuffleDigit,
                              },
                              on: {
                                click: _vm.shuffleButton,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-random mr-2",
                              }),
                              _vm._v(" สลับเลข\n          "),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.digits_double, function (item, index) {
                        return _c("button-item", {
                          key: item.index,
                          staticClass: "col-2",
                          attrs: {
                            "class-button": _vm.getRateClass(
                              _vm.digitType,
                              item
                            ),
                            "key-value": item,
                            "lotto-numbers-with-type": _vm.lottoNumbersWithType,
                            "digit-type": _vm.digitType,
                          },
                          on: {
                            "child-digitClick": _vm.digitClick,
                          },
                        })
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm.selectedDigitType == 3
        ? _c(
            "div",
            {
              staticClass: "row-old-col",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-10 d-flex col-lg-5 px-0",
                },
                _vm._l(_vm.button_triple_secments_1, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.index,
                      staticClass: "flex-width mb-3 mx-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-yellow w-100",
                          class: {
                            active: item.segment == _vm.selected,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.pushButtonTriple(item.segment)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.des) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-10 d-flex col-lg-5 px-0",
                },
                _vm._l(_vm.button_triple_secments_2, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.index,
                      staticClass: "flex-width mb-3 mx-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-yellow w-100",
                          class: {
                            active: item.segment == _vm.selected,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.pushButtonTriple(item.segment)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.des) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 px-1 mb-2",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "w-100 btn btn-outline-dark",
                      class: {
                        active: _vm.shuffleDigitTripple,
                      },
                      on: {
                        click: _vm.shuffleTripple,
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-random mr-2",
                      }),
                      _vm._v(" สลับเลข\n      "),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.digits_triple, function (item, index) {
                return _c("button-item", {
                  key: item.index,
                  staticClass: "col-2",
                  attrs: {
                    "class-button": _vm.getRateClass(_vm.digitType, item),
                    "key-value": item,
                    "lotto-numbers-with-type": _vm.lottoNumbersWithType,
                    "digit-type": _vm.digitType,
                  },
                  on: {
                    "child-digitClick": _vm.digitClick,
                  },
                })
              }),
            ],
            2
          )
        : _vm.selectedDigitType == 4
        ? _c(
            "div",
            {
              staticClass: "row-old-col",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-10 d-flex col-lg-5 px-0",
                },
                _vm._l(_vm.button_triple_secments_1, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.index,
                      staticClass: "flex-width mb-3 mx-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-yellow w-100",
                          class: {
                            active: item.segment == _vm.selected,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.pushButtonTriple(item.segment)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.des) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-10 d-flex col-lg-5 px-0",
                },
                _vm._l(_vm.button_triple_secments_2, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.index,
                      staticClass: "flex-width mb-3 mx-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-yellow w-100",
                          class: {
                            active: item.segment == _vm.selected,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.pushButtonTriple(item.segment)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.des) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 px-1 mb-2",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "w-100 btn btn-outline-dark",
                      class: {
                        active: _vm.shuffleDigitTripple,
                      },
                      on: {
                        click: _vm.shuffleTripple,
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-random mr-2",
                      }),
                      _vm._v(" สลับเลข\n      "),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.digits_triple, function (item, index) {
                return _c("button-item", {
                  key: item.index,
                  staticClass: "col-2",
                  attrs: {
                    "class-button": _vm.getRateClass(_vm.digitType, item),
                    "key-value": item,
                    "lotto-numbers-with-type": _vm.lottoNumbersWithType,
                    "digit-type": _vm.digitType,
                  },
                  on: {
                    "child-digitClick": _vm.digitClick,
                  },
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }